import { z } from 'zod'

// Allows for creating a ZodEnum from the keys of an object, in cases where we don't want to create a const array of strings manually
export function getZodEnumFromObjectKeys<
  TI extends Record<string, unknown>,
  R extends string = TI extends Record<infer R, unknown> ? R : never,
>(input: TI): z.ZodEnum<[R, ...R[]]> {
  const [firstKey, ...otherKeys] = Object.keys(input) as [R, ...R[]]
  return z.enum([firstKey, ...otherKeys])
}
